import {autoScrollOff, isAutoScrollOn} from '../reducers/autoScrollReducer';
import {considerUserActivity, onUserActivityConsidered} from '../reducers/userActivityReducer';

export default function onUserActivity(state) {
    return dispatch => {
        if (isAutoScrollOn(state)) {
            dispatch(autoScrollOff());
        }
        dispatch(considerUserActivity());
        dispatch(onUserActivityConsidered());
    }
}


// WEBPACK FOOTER //
// ./src/actions/user-activity.js